import useEvent from "react-use/lib/useEvent";
import styled, { css } from "styled-components";
import React, { memo, useMemo, useState, useCallback } from "react";
import Panel from "../../Layout/Panel";
const directions = {
  down: css(["transform:translateX(0);"])
};
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1j5n4o9-0"
})(["position:relative;&:hover > *:last-child{opacity:1;pointer-events:all;}"]);
const Trigger = /*#__PURE__*/styled.div.withConfig({
  displayName: "Trigger",
  componentId: "sc-1j5n4o9-1"
})(["position:relative;z-index:2;"]);
const Content = /*#__PURE__*/styled(Panel).withConfig({
  displayName: "Content",
  componentId: "sc-1j5n4o9-2"
})(["", " position:absolute;z-index:1;top:-8px;right:-8px;left:-8px;display:flex;align-items:center;justify-content:center;padding:60px 0 8px;opacity:0;pointer-events:none;"], ({
  direction
}) => directions[direction]);
const Dropdown = /*#__PURE__*/memo(({
  trigger,
  children,
  direction
}) => {
  // const [active, setActive] = useState(false);

  // const onClick = useCallback(() => setActive(true), []);
  // const onClickOutside = useCallback(() => setActive(false), []);

  // trigger = useMemo(() => React.cloneElement(trigger, { onClick }), [onClick, trigger]);

  // useEvent("click", active && onClickOutside);

  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(Trigger, null, trigger), /*#__PURE__*/React.createElement(Content, {
    background: "secondary",
    direction: direction
  }, children));
});
Dropdown.displayName = "Dropdown";
export default Dropdown;
//# sourceMappingURL=index.js.map